import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { PSV_REVIEW_NOTE_LIMIT } from "@api/shared-runtime/psv-review";
import { Button } from "@/components/ui/button";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import { Textarea } from "@/components/ui/textarea";

/** The optional "Add note or evidence" disclosure. The draft is owned by the
 * parent so Save note sits with Accept and Concern. Remount it (key by the
 * saved note) to reset the draft when the server's note changes. */
export function ItemNote({
  title,
  draft,
  onDraftChange,
  defaultOpen,
  children,
}: {
  title: string;
  draft: string;
  onDraftChange: (note: string) => void;
  defaultOpen: boolean;
  children: React.ReactNode;
}) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <Collapsible open={open} onOpenChange={setOpen} className="space-y-2">
      <CollapsibleTrigger asChild>
        <Button
          type="button"
          variant="link"
          size="sm"
          className="group h-auto gap-1 p-0 text-xs text-muted-foreground"
        >
          Add note or evidence
          <ChevronDown
            className="size-3 transition-transform group-data-[state=open]:rotate-180"
            aria-hidden
          />
        </Button>
      </CollapsibleTrigger>
      <CollapsibleContent className="space-y-3">
        <Textarea
          aria-label={`Note for ${title}`}
          value={draft}
          maxLength={PSV_REVIEW_NOTE_LIMIT}
          rows={3}
          placeholder="Add a note for the record"
          onChange={(event) => onDraftChange(event.target.value)}
        />
        <div className="flex flex-wrap items-center gap-2">{children}</div>
      </CollapsibleContent>
    </Collapsible>
  );
}
